/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import torque from "assets/images/logos/gray-logos/logo-torque.svg";
import office from "assets/images/logos/gray-logos/logo-office.svg";
import dromex from "assets/images/logos/gray-logos/logo-dromex.svg";
import greeff from "assets/images/logos/gray-logos/logo-greeff.svg";
import haosh from "assets/images/logos/gray-logos/logo-haosh.svg";
import rs from "assets/images/logos/gray-logos/logo-rs.svg";
import cromwell from "assets/images/logos/gray-logos/logo-cromwell.svg";
import eis from "assets/images/logos/gray-logos/logo-eis.svg";
import baogang from "assets/images/logos/gray-logos/logo-baogang.svg";
import armor from "assets/images/logos/gray-logos/logo-armor.svg";
import ideal from "assets/images/logos/gray-logos/logo-ideal.svg";
import bmg from "assets/images/logos/gray-logos/logo-bmg.svg";

function Featuring() {
  return (
    <MKBox component="section" pt={2} pb={1} id="our-suppliers">
      <Grid
        container
        item
        xs={12}
        lg={6}
        flexDirection="column"
        alignItems="center"
        sx={{ textAlign: "center", my: 2, mx: "auto", px: 0.75 }}
      >
        <MKTypography
          variant="h2"
          fontWeight="bold"
          sx={{ textAlign: "center", my: 2, mx: "auto", px: 0.75 }}
        >
          Our Trusted Suppliers
        </MKTypography>
      </Grid>
      <Container>
        <Grid container spacing={2} sx={{ mb: 12 }}>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={torque} alt="torque" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={office} alt="office" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={dromex} alt="dromex" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={greeff} alt="greeff" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={haosh} alt="haosh" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={rs} alt="rs" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={cromwell} alt="cromwell" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={eis} alt="eis" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={baogang} alt="baogang" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={armor} alt="armor" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={ideal} alt="ideal" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={bmg} alt="bmg" width="100%" opacity={0.7} />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Featuring;
